var map = {
	"./coin_1.png": "c375",
	"./coin_2.png": "14b4",
	"./coin_3.png": "c688",
	"./coin_4.png": "e267",
	"./coin_5.png": "6a0c",
	"./coin_6.png": "9771",
	"./coin_7.png": "854b",
	"./coin_8.png": "4189",
	"./coin_9.png": "a134"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a798";